import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Autocomplete as Autocomplete$1, FormControl, TextField } from '@mui/material';
import { spacing } from '@mui/system';

const Container = styled(Autocomplete$1)(spacing);
const Autocomplete = _a => {
  var {
      label,
      shrink = undefined,
      size = 'medium',
      minWidth
    } = _a,
    props = __rest(_a, ["label", "shrink", "size", "minWidth"]);
  return jsx(Container, Object.assign({}, props, {
    disablePortal: true,
    size: size,
    renderInput: params => jsx(FormControl, Object.assign({
      error: props.error,
      sx: {
        minWidth
      },
      disabled: props.disabled
    }, {
      children: jsx(TextField, Object.assign({}, params, {
        error: props.error,
        helperText: props.helperText,
        size: size,
        InputLabelProps: {
          shrink: shrink ? true : undefined
        },
        variant: "outlined",
        label: label
      }))
    }))
  }));
};

export { Autocomplete };
